<template>
    <v-layout row wrap>        
        <ui-title-red textTitle="Actividad"></ui-title-red>
        <actividad-decisiones></actividad-decisiones>
    </v-layout>
</template>

<script>
import ActividadDes from '../../actividades/ActividadDecisiones';
export default {
  components: {
    'actividad-decisiones': ActividadDes
  },
  data() {
    return {};
  },
  mounted() {
    this.$store.commit("nextShow", false);
  }
};
</script>


// WEBPACK FOOTER //
// davivienda-08.vue?7453a372